/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from 'react';
import { SignInContainer } from './container';
import { useNavigate } from 'react-router-dom';
import RouteConfig from '@/AppNavigator/services/config/routes.config.json';

export const SignInPage = ({ navigation }: { navigation: any }) => {
  const navigate = useNavigate();
  return (
    <SignInContainer
      onRedirectSignIn={(email: string) => {
        navigate(`${RouteConfig?.routes?.SignUp?.path}`, {
          state: { email: email },
        });
      }}
    />
  );
};
